import { ReactNode } from "react";
import './input-number.css'
import TextInput from "./input-text.tsx";

export default function NumberInput (props: {
	label?: string,
	value: number,
  step: number,
  min?: number,
  max?: number,
  decimals?:number, 
  placeholder?:number,
  unit?: string,
  disabled?: boolean,
  infoButton?: ReactNode,
  onChange: (value: number | undefined) => void,
  onBlur?: () => void,
  validate?: (value: string) => Promise<boolean>, 
}){
  return <TextInput infoButton={props.infoButton} type="number" min={props.min} max={props.max} decimals={props.decimals} onBlur={props.onBlur} step={props.step} postfix={props.unit} label={props.label} value={props.value} placeholder={props.placeholder ? props.placeholder.toString() : ""}  disabled={props.disabled} onChange={(value)=>{
    if(value){
      props.onChange(parseFloat(value));
    }else{
      props.onChange(undefined);
    }
  }}
  validate={props.validate}/>
}
